var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavmii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03287 12.02C2.03287 9.76898 1.97349 7.51619 2.04906 5.26881C2.12284 3.115 3.26542 2.05519 5.42463 2.0336C8.20821 2.00661 10.9936 1.97062 13.7772 2.04079C18.5958 2.16315 21.311 4.99352 21.3164 9.79417C21.32 12.6965 21.338 15.5989 21.32 18.5012C21.3056 20.7144 20.2476 21.9613 18.4141 21.9991C16.532 22.0369 15.4542 20.8619 15.4236 18.6181C15.384 15.8346 15.4326 13.0492 15.4038 10.2656C15.3768 7.67814 14.0831 6.37182 11.6198 6.36642C9.25723 6.36282 7.91132 7.77351 7.88793 10.3466C7.86274 13.0708 7.89513 15.7968 7.87894 18.521C7.86454 20.8367 6.82992 21.9883 4.80745 21.9973C2.84257 22.0063 2.06526 21.0958 2.02027 18.5948C1.98069 16.405 2.01127 14.2116 2.01127 12.02H2.03287Z",
    fill: "#056FEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavmii);
export default __webpack_public_path__ + "static/media/navmii.3b04c2ca9d23d760ea4247b5d84e9b05.svg";
export { ForwardRef as ReactComponent };